<template>
  <div class="base-layout w-full h-screen flex items-center justify-center">
    <div>
      <icon name="TypingDots" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFallback",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  computed: {
    logged: function() {
      return this.$store.getters["auth/logged"];
    }
  },
  created() {
    if (
      this.$store.getters["auth/token"] &&
      this.$store.getters["auth/token"] !== null
    ) {
      this.$router.push("/");
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
